module.exports = __webpack_public_path__ + "img/szhxNo1.963d3d2d.png";